/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Tournament_1_HeadingInputs */

const en_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetic chain sequencing`)
};

const es_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secuenciación de la cadena cinética`)
};

const de_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetische Kettensequenzierung`)
};

const zh_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动力链的发力顺序`)
};

const ar_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسلسل السلسلة الحركية`)
};

const fr_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séquence de la chaîne cinétique`)
};

const vi_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình tự chuỗi động lực`)
};

const sw_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mfuatano wa mnyororo wa kinetiki`)
};

const th_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลำดับการส่งแรงในห่วงโซ่การเคลื่อนไหว`)
};

const bs_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekvenciranje kinetičkog lanca`)
};

const ja_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運動連鎖の順序`)
};

const ko_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키네틱 체인의 순서`)
};

const pt_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenciamento da cadeia cinética`)
};

const it_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenza della catena cinetica`)
};

const sv_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekvensering i den kinetiska kedjan`)
};

const nl_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgorde in de kinetische keten`)
};

const da_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekvensering i den kinetiske kæde`)
};

const nb_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekvensering i den kinetiske kjeden`)
};

const fi_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kineettisen ketjun ajoitus`)
};

const pl_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekwencja łańcucha kinetycznego`)
};

const ru_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последовательность кинетической цепи`)
};

const tr_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetik zincir sıralaması`)
};

const hi_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`काइनेटिक श्रृंखला का क्रम`)
};

const id_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutan rantai kinetik`)
};

const ms_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutan rantaian kinetik`)
};

const cs_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sled kinetického řetězce`)
};

const el_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αλληλουχία της κινητικής αλυσίδας`)
};

const he_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רצף השרשרת הקינטית`)
};

const af_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinetiese-kettingvolgorde`)
};

const hu_method_content_step_05_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kinetikus lánc sorrendje`)
};

/**
* | output |
* | --- |
* | "Kinetic chain sequencing" |
*
* @param {Method_Content_Step_05_Detail_Tournament_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_tournament_1_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Tournament_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Tournament_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_tournament_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_tournament_1_heading(inputs)
	return en_method_content_step_05_detail_tournament_1_heading(inputs)
});